<template>
  <div>
    <h1 class="page-title"><i class="fal fa-code"></i> Dev's Lounge</h1>
    <div class="columns">
      <div class="is-menu">
        <button class="button menu-button is-info is-outlined is-fullwidth" @click="view='overview'" :class="{ 'menu-item-active': (view === 'overview') }">Översikt</button>
        <button class="button menu-button is-info is-outlined is-fullwidth" @click="view='fortnox'" :class="{ 'menu-item-active': (view === 'fortnox') }">Fortnox</button>
      </div>
      <div class="column">
        <overview v-if="view === 'overview'" />
        <fortnox v-if="view === 'fortnox'" />
      </div>
    </div>
  </div>
</template>

<script>

import Overview from '@/components/pages/Admin/Settings/DevPageViews/Overview'
import Fortnox from '@/components/pages/Admin/Settings/DevPageViews/Fortnox'

export default {
  components: {
    Overview,
    Fortnox
  },
  data () {
    return {
      view: 'overview'
    }
  }
}
</script>

<style lang="scss" scoped>
  .is-menu {
    padding: 0.75rem;
    width: 14rem;
  }
  .menu-button {
    margin-bottom: 0.5rem;
  }
  .menu-item-active {
    background-image: linear-gradient(to bottom, #b9bfff, #c2cbff, #ccd6ff, #d8e1ff, #e5ecff, #e1f0ff, #e0f4ff, #e0f8ff, #c5f9ff, #a6faff, #84fbfc, #5ffbf1);
    color: rgba(0, 0, 0, 0.5) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/DevPage.vue